import React, { useEffect } from "react";
import "./ScrollImg.css";

import d1 from "../../Assets/project9/d1.webp";
import d2 from "../../Assets/project9/d2.webp";
import d3 from "../../Assets/project9/d3.webp";
import d4 from "../../Assets/project9/d4.webp";
import d5 from "../../Assets/project9/d5.webp";
import d6 from "../../Assets/project9/d6.webp";
import d7 from "../../Assets/project9/d7.webp";
import d8 from "../../Assets/project9/d8.webp";
import d9 from "../../Assets/project9/d9.webp";
import d10 from "../../Assets/project9/d10.webp";
import d11 from "../../Assets/project9/d11.webp";
import d12 from "../../Assets/project9/d12.webp";
import d13 from "../../Assets/project9/d13.webp";
import d14 from "../../Assets/project9/d14.webp";
import d15 from "../../Assets/project9/d15.webp";
import d16 from "../../Assets/project9/d16.webp";
import d17 from "../../Assets/project9/d17.webp";

const ScrollImg9 = () => {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      const scroll = window.scrollY + window.innerHeight / 3;

      let isActiveSectionFound = false;

      sections.forEach((section) => {
        const top = section.offsetTop;
        const height = section.offsetHeight;

        if (top <= scroll && top + height > scroll) {
          sections.forEach((s) => s.classList.remove("active"));
          section.classList.add("active");
          isActiveSectionFound = true;
        }
      });

      // If no section is in view, ensure all are inactive
      if (!isActiveSectionFound) {
        sections.forEach((s) => s.classList.remove("active"));
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger the scroll effect initially
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const images = [
    d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16, d17,
  ];

  return (
    <div>
      {images.map((image, index) => (
        <div key={index} className="section">
          <div className="section-img">
            <div
              className="section-img-inner"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScrollImg9;
